// extracted by mini-css-extract-plugin
export default {"collapse":"StagesForm_collapse__JTWIV"};